<template>
  <div class="container">
    <div class="headline">数据分析</div>
    <div class="information">
      <ul>
        <li>
          <span class="word">全国12358价格监管平台2019年5月分析报告</span>
          <span class="link"><a target="_blank" href="http://www.samr.gov.cn/sj/fxbg/201906/t20190620_302512.html">查看</a></span>
        </li>
      </ul>
    </div>
    <div class="information">
      <ul>
        <li>
          <span class="word">全国12358价格监管平台2019年4月分析报告</span>
          <span class="link"><a target="_blank" href="http://www.samr.gov.cn/sj/fxbg/201905/t20190522_294908.html">查看</a></span>
        </li>
      </ul>
    </div>
    <div class="information">
      <ul>
        <li>
          <span class="word">全国12358价格监管平台2019年一季度分析报告</span>
          <span class="link"><a target="_blank" href="http://www.samr.gov.cn/sj/fxbg/201907/t20190702_303138.html">查看</a></span>
        </li>
      </ul>
    </div>
    <div class="information">
      <ul>
        <li>
          <span class="word">2018年前三季度市场环境形势分析报告</span>
          <span class="link"><a target="_blank" href="http://www.samr.gov.cn/zhghs/schjxsfx/201902/t20190227_291491.html">查看</a></span>
        </li>
      </ul>
    </div>
    <div class="information">
      <ul>
        <li>
          <span class="word">2018年上半年市场环境形势分析报告</span>
          <span class="link"><a target="_blank" href="http://www.samr.gov.cn/sj/fxbg/201902/t20190227_291489.html">查看</a></span>
        </li>
      </ul>
    </div>
    <div class="information">
      <ul>
        <li>
          <span class="word">2018年一季度市场环境形势分析报告</span>
          <span class="link"><a target="_blank" href="http://www.samr.gov.cn/zhghs/schjxsfx/201902/t20190227_291488.html">查看</a></span>
        </li>
      </ul>
    </div>
    <div class="information">
      <ul>
        <li>
          <span class="word">全国12358价格监管平台2018年11月分析报告</span>
          <span class="link"><a target="_blank" href="http://www.samr.gov.cn/sj/fxbg/201812/t20181217_290099.html">查看</a></span>
        </li>
      </ul>
    </div>
    <div class="information">
      <ul>
        <li>
          <span class="word">全国12358价格监管平台2018年10月分析报告</span>
          <span class="link"><a to="/test2" target="_blank" href="http://www.samr.gov.cn/sj/fxbg/201811/t20181113_290098.html">查看</a></span>
        </li>
      </ul>
    </div>
    <div class="information">
      <ul>
        <li>
          <span class="word">全国12358价格监管平台2018年8月分析报告</span>
          <span class="link"><a to="/test2" target="_blank" href="http://www.samr.gov.cn/sj/fxbg/201809/t20180930_290097.html">查看</a></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'analysisData'
}
</script>

<style scoped lang="less">
.container{
  position: relative;
  width: @body-width ;
  margin: 0 auto;
  .headline{
    border-left: 4px solid @color-base;
    border-bottom: 1px solid rgba(0, 141, 255, 0.2);
    width: @body-width ;
    line-height: 60px;
    background: #c8e4ff;
    height: 60px;
    font-size: 24px;
    font-weight: 500;
    color: #000000;
    padding: 0 30px;
  }
  .information{
    cursor: pointer;
    margin-top: 5px;
    width: @body-width ;
    line-height: 60px;
    background-color: #fff;
    padding: 5px 30px;
    border: 1px solid rgba(0, 0, 0, .1);
    ul li:before {
      content: "\2022"; //圆点
      color: rgba(0, 0, 0, 0.25); //颜色
      font-size: 16px;
      padding-right: 8px; //大小
    }
    .word{
      font-size: 16px;
      font-weight: 600;
      color: #000000;
    }
    .link{
      cursor: pointer;
      margin-top: 15px;
      width: 88px;
      line-height: 28px;
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      font-size: 12px;
      text-align: center;
      font-weight: 500;
      float: right;
      a{
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .link:hover{
      border: 1px solid rgba(0, 141, 255, 1);
    }
    .link:hover a{
      color: rgba(0, 141, 255, 1);
    }
  }
  .information:hover{
    box-shadow:0px 6px 10px 0px rgba(0,141,255,0.1);
    border:1px solid rgba(0,141,255,0.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/analysis/analysisData.vue